module.exports = __webpack_public_path__ + "static/BBC-screenshots-4416da6abcd378dac74918dceece3d6a.jpg";